/* eslint no-unused-vars: 0 */

import React from 'react';
import { handleUnit } from 'lib/utils';
import SiteSearchProductNoResults from './product_no_results';

class SiteSearchProductResults extends React.PureComponent {
  constructor(props) {
    super(props);
    this.getPrice = this.getPrice.bind(this);
  }

  getPrice(id) {
    const price = this.props.prices[id];

    return price !== undefined ? (
      <div className="price">
        <div className="price-inc-moq">
          <span className="priceValue">
            £
            {this.props.vat_exclusive == true
              ? price['price'].toFixed(2)
              : price['price_inclusive'].toFixed(2)}{' '}
          </span>

          <span className="moq">
            {' '}
            For {price['quantity']}
            {handleUnit(price['unit'])}
          </span>
        </div>
        <div className="vat-switch">
          {this.props.vat_exclusive == true ? (
            <span>£{price['price_inclusive'].toFixed(2)} inc VAT</span>
          ) : (
            <span>£{price['price'].toFixed(2)} ex VAT</span>
          )}
        </div>
      </div>
    ) : (
      ''
    );
  }

  render() {
    return (
      <div className="span9 product-results">
        {this.props.products.length > 0 ? (
          <h3>Popular Products</h3>
        ) : (
          <SiteSearchProductNoResults
            customerServicesEmail={this.props.customerServicesEmail}
            b2bPhoneNumber={this.props.b2bPhoneNumber}
            assets={this.props.assets}
            query={this.props.query}
          />
        )}
        <ul>
          {this.props.products.map((p, index) => {
            return (
              <li
                key={index}
                onClick={e => {
                  if (window.dataLayer) {
                    window.dataLayer.push({
                      event: 'AutoSearchPopular',
                      name: p.description_short,
                      stockCode: p.stock_code,
                      searchUsed: this.props.query,
                      position: index + 1,
                    });
                  }
                  this.props.viewLink(p.url);
                }}>
                <div className="search-result">
                  <div className="sr-product-image">
                    <img src={p.image_small} className="product-thumbnail" />
                  </div>
                  <div className="sr-brand-image">
                    {p.brand_image !== null ? (
                      <img
                        src={p.brand_image}
                        className="product-brand-thumbnail"
                      />
                    ) : (
                      ''
                    )}
                  </div>

                  <div className="product--detail">
                    <div>
                      <strong className="description">
                        {p.description_short}
                      </strong>
                      <br />
                      <span>Part Code:</span> <strong>{p.catalogue}</strong>{' '}
                      &nbsp;
                      <span>Stock Code:</span> <strong>{p.stock_code}</strong>
                    </div>
                    <div>
                      {this.props.loadingPrices === true && (
                        <div className="loader">{''}</div>
                      )}
                      {this.getPrice(p.id)}
                    </div>
                  </div>

                  <div
                    className={
                      'stock-level' +
                      (p.b2b_stock_level <= 0 ? ' out-of-stock' : '')
                    }>
                    {p.third_party_logistical_partner ? (
                      <span className="ta-c contact-store">
                        <strong>Contact Store for Details</strong>
                      </span>
                    ) : (
                      <>
                        {p.b2b_stock_level > 0 ? (
                          <div>
                            <div>
                              <strong>Delivery</strong>
                            </div>
                            <div>
                              <strong className="instock">
                                {p.b2b_stock_level}
                              </strong>{' '}
                              in stock
                            </div>
                          </div>
                        ) : (
                          'Out of Stock'
                        )}
                      </>
                    )}
                  </div>
                </div>
              </li>
            );
          })}
          {this.props.products.length > 0 ? (
            <li>
              <button
                onClick={e => {
                  this.props.fullSearch();
                }}>
                SHOW ALL RESULTS
              </button>
            </li>
          ) : (
            ''
          )}
        </ul>
      </div>
    );
  }
}

export default SiteSearchProductResults;
